<template>
  <div class="cell">
    <div
      class="breadcrumb-grid grid-x align-center grid-margin-x"
      :class="payload.afterHero ? 'after-hero' : ''"
    >
      <div class="cell small-12 large-6">
        <p>
          <span>
            <router-link data-hover="link" :to="{name: 'home', params: {locale: $i18n.locale}}">Home</router-link>&nbsp;/
          </span>
          <span v-for="(bread, key) in payload.elements" :key="key">
            <router-link data-hover="link" :to="bread.url">{{bread.text}}</router-link>&nbsp;/
          </span>
          <span>{{payload.current}}</span>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    payload: {
      default: () => {},
      required: false
    }
  }
  // mounted() {
  //   this.elements = this.$route.matched;
  //   this.elements.splice(0, 1);
  // }
};
</script>

<style lang="scss" scoped>
@import "@assets/scss/_importer.scss";
.breadcrumb-grid {
  overflow: hidden;
  position: relative;
  z-index: 1;
  &.after-hero {
    margin-top: 64px;
    margin-bottom: 64px;
  }
  .cell {
    p {
      margin-bottom: 0;
      span {
        a {
          font-weight: $global-weight-bold;
          text-decoration: underline;
          &:hover {
            text-decoration: unset;
          }
        }
      }
    }
  }
}
</style>

